import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { productStructureApi, type Bundle, type BundleType } from '../../api/productstructure';

function BundleForm({ type, title }: { type: BundleType; title: string }) {
  const [items, setItems] = useState<Bundle[]>([]);
  const [name, setName] = useState('');
  const [productIds, setProductIds] = useState('');
  const [error, setError] = useState('');

  const reload = () => {
    void productStructureApi.listBundles({ type }).then(setItems).catch((e) => setError(String(e)));
  };

  useEffect(() => { reload(); }, []);

  const create = async () => {
    if (!name.trim()) return;
    try {
      await productStructureApi.createBundle({
        name: name.trim(),
        type,
        items: productIds.split(',').map((s) => s.trim()).filter(Boolean).map((id) => ({ product_id: id, quantity: 1 })),
      });
      setName('');
      setProductIds('');
      reload();
    } catch (e) {
      setError(String(e));
    }
  };

  return (
    <div>
      <h1 className="text-2xl font-semibold">{title}</h1>
      <div className="mt-4 flex flex-wrap gap-2">
        <input value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" className="rounded-lg border px-3 py-2 text-sm" />
        <input value={productIds} onChange={(e) => setProductIds(e.target.value)} placeholder="Product IDs (comma-separated)" className="min-w-[240px] rounded-lg border px-3 py-2 text-sm" />
        <button type="button" onClick={() => void create()} className="rounded-lg bg-slate-900 px-4 py-2 text-sm text-white">Create</button>
      </div>
      {error && <p className="mt-4 text-sm text-red-600">{error}</p>}
      <table className="mt-6 min-w-full rounded-xl border bg-white text-sm">
        <thead className="border-b bg-slate-50 text-left text-slate-600">
          <tr><th className="px-4 py-3">Name</th><th className="px-4 py-3">Items</th><th className="px-4 py-3">Status</th></tr>
        </thead>
        <tbody>
          {items.map((b) => (
            <tr key={b.id} className="border-b">
              <td className="px-4 py-3 font-medium">{b.name}</td>
              <td className="px-4 py-3">{b.items?.length ?? 0}</td>
              <td className="px-4 py-3">{b.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export function BundleBuilderPage() {
  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/product-structure" className="text-sm text-slate-600 hover:underline">← Structure hub</Link>
      <div className="mt-4"><BundleForm type="bundle" title="Bundle Builder" /></div>
    </div>
  );
}

export function KitBuilderPage() {
  return (
    <div className="mx-auto max-w-6xl p-6">
      <Link to="/product-structure" className="text-sm text-slate-600 hover:underline">← Structure hub</Link>
      <div className="mt-4"><BundleForm type="kit" title="Kit Builder" /></div>
    </div>
  );
}
